// Утилита для построения query string с массивом id[]
export const buildQueryString = (params) => {
  const parts = [];

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length === 1) {
      value = value[0];
    }
    if (Array.isArray(value)) {
      value.forEach((item) => {
        // Не кодируем [], сервер ожидает именно id[]
        parts.push(`${key}[]=${encodeURIComponent(item)}`);
      });
    } else {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  });

  return parts.join("&");
};
